module.exports = __webpack_public_path__ + "static/media/datepicker.8b6e906d.svg";